// @ts-nocheck
import AssignmentForm from "./assignmentForm";
//--------------------------------------------------------------------------------------------
export default function LocatingPreChecklist({
    ...rest
}){
    //--------------------------------------------------------------------------------------------
    const items = [
        {title: "Are USA delineations visible?",  type: "radio", required: true},
        {title: "Are utility marks visible?",  type: "radio", required: true},
        {title: "Are utility plans available?",  type: "radio", required: true},
        {title: "Do you have the site contact's information?",  type: "radio", required: true},
        {title: "Was the scope of work discussed with the customer representative?",  type: "radio", required: true},
        {title: "Are the project boundaries clearly identified and verified?",  type: "radio", required: true},
        {title: "Is utility equipment in acceptable conditions to complete the required work?",  type: "radio", required: true},
        {title: "Was a safety tailgate meeting completed?", type: "radio", required: true}
    ];
    //--------------------------------------------------------------------------------------------
    return(
        <AssignmentForm
            noPDF
            items = {items}
            {...rest}
        />
    )    
}
